export default __webpack_public_path__ + "static/media/38.2cd2c772.jpeg";